import '@glidejs/glide/dist/css/glide.core.min.css';
import '@glidejs/glide/dist/css/glide.theme.min.css';
import 'glightbox/dist/css/glightbox.css';

import './controllers/default';
import './controllers/homepage';
import './controllers/animation';

import { WPPages } from "../domain/modules/wp-pages";
import GLightbox from 'glightbox';
import { waitForElement } from '../domain/util/wait-for-element';

export default (async () => {
  window.addEventListener('load', async () => {
    // @ts-ignore
    import('./controllers/navigation');
    import('./controllers/all');

    if(WPPages.isOnAboutPage()){
      await import('./controllers/about'); 
    } 
    
  })
  
  await waitForElement('.glightbox')
  GLightbox({ autoplayVideos: true });
  
})();


